import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {fetchDataNew} from "../../hook/axios.hook";

const initialState = {
  todos: [],
  todo: null,
  loading: false,
  error: false,
};

export const fetchAllTodos = createAsyncThunk(
  "todos/getAll",
  async ({todoType, ...params}, {rejectWithValue, signal}) =>
    fetchDataNew(`${todoType}s/todos/getAll`, "get", {params, rejectWithValue, signal}),
);
export const fetchTodoById = createAsyncThunk("todos/getTodoById", async ({todoType, todoId}) =>
  fetchDataNew(`${todoType}s/todos/get/${todoId}`, "get"),
);
export const createTodo = createAsyncThunk("todos/createTodo", async ({todoType, entityId, ...body}) =>
  fetchDataNew(`${todoType}s/todos/add/${entityId}`, "post", {body}),
);
export const updateTodo = createAsyncThunk("todos/updateTodo", async ({todoType, todoId, ...body}) =>
  fetchDataNew(`${todoType}s/todos/update/${todoId}`, "patch", {body}),
);
export const markAsDoneTodo = createAsyncThunk("todos/asDoneTodo", async ({todoType, todoId}) =>
  fetchDataNew(`${todoType}s/todos/markAsDone/${todoId}`, "put"),
);
export const deleteTodo = createAsyncThunk("todos/removeTodo", async ({todoType, todoId}) =>
  fetchDataNew(`${todoType}s/todos/remove/${todoId}`, "delete").then(() => todoId),
);

function handlePending(state) {
  state.loading = true;
  state.error = false;
}

function handleRejected(state, error) {
  state.loading = false;
  state.error = error;
}

const todoSlice = createSlice({
  name: "todoStore",
  initialState,
  reducers: {
    clearCurrentTodo: state => {
      state.todo = null;
    },
    clearStateTodos: state => {
      state.todos = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAllTodos.pending, handlePending)
      .addCase(fetchAllTodos.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.loading = false;
          return;
        }
        state.todos = payload;
        state.loading = false;
      })
      .addCase(fetchAllTodos.rejected, handleRejected)
      .addCase(fetchTodoById.pending, handlePending)
      .addCase(fetchTodoById.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.loading = false;
          return;
        }
        state.todo = payload;
        state.loading = false;
      })
      .addCase(fetchTodoById.rejected, handleRejected)
      .addCase(createTodo.pending, handlePending)
      .addCase(createTodo.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.loading = false;
          return;
        }
        state.todos.unshift(payload);
        state.todo = payload;
        state.loading = false;
      })
      .addCase(createTodo.rejected, handleRejected)
      .addCase(updateTodo.pending, handlePending)
      .addCase(updateTodo.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.loading = false;
          return;
        }
        const index = state.todos.findIndex(({todoId}) => todoId === payload.todoId);
        if (index !== -1) {
          state.todos[index] = payload;
          state.todo = payload;
        }
        state.loading = false;
      })
      .addCase(updateTodo.rejected, handleRejected)
      .addCase(markAsDoneTodo.pending, handlePending)
      .addCase(markAsDoneTodo.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.loading = false;
          return;
        }
        const index = state.todos.findIndex(({todoId}) => todoId === payload.todoId);
        if (index !== -1) {
          state.todos[index] = payload;
          state.todo = payload;
        }
        state.loading = false;
      })
      .addCase(markAsDoneTodo.rejected, handleRejected)
      .addCase(deleteTodo.pending, handlePending)
      .addCase(deleteTodo.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.loading = false;
          return;
        }
        state.todos = state.todos.filter(({todoId}) => todoId !== payload);
        state.todo = null;
        state.loading = false;
      })
      .addCase(deleteTodo.rejected, handleRejected);
  },
});
const {actions, reducer} = todoSlice;
export const {clearCurrentTodo, clearStateTodos} = actions;
export default reducer;

export const selectAllTodos = state => state.todoStore.todos;
export const selectTodo = state => state.todoStore.todo;
export const selectLoading = state => state.todoStore.loading;
